import css from 'styled-jsx/css';

export default css`
  .pc-model-intro-specs {
    display: flex;
    justify-content: center;
    align-items: center;
    background: transparent;
    opacity: 0.75;
    padding: 0;
    border: 0;
  }
  .pc-model-intro-specs .text {
    margin-left: 5px;
    font-size: 13px;
    line-height: 20px;
    text-transform: none;
  }
  .text {
    font-family: 'Roboto-Medium';
    font-size: 13px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;
  }
  .darkText {
    color: #242424;
  }
  .lightText {
    color: #e4e4e4;
  }
`;
